export const apiAuth = process.env.VUE_APP_API
export const apiCore = process.env.VUE_APP_API
